import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    background: {
      default: "#f0f0f0", // main content background
      paper: "#fff",
    },
    backgroundMainContent: "#321919ff",
    backgroundSidebar: "#321919ff",
    backgroundTopNav: "#d0d0d0",
    backgroundFooter: "#a75858ff",

    text: {
      primary: "#333",
      secondary: "#555",
    },
    textMainContent: "#111",
    textTopNav: "#222",
    textSidebar: "#111",
    textFooter: "#444",
  },
});

export default theme;
